import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';

const IsLoggedIn: FC = () => {
  const { isLoading, isLoadingProfile, session } = useAuthContext();

  const loading = isLoading || (!!session && isLoadingProfile);

  if (!session && !isLoading) {
    return <Navigate to={Routes.LOGIN} />;
  }

  return <Middleware isLoading={loading}>{session ? <Outlet /> : null}</Middleware>;
};

export default IsLoggedIn;
